module.exports = __webpack_public_path__ + "static/media/webLogo2.6b4a5e24.svg";